import { render, staticRenderFns } from "./list_gtjy.vue?vue&type=template&id=a729ed20&scoped=true"
import script from "./list_gtjy.vue?vue&type=script&lang=js"
export * from "./list_gtjy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a729ed20",
  null
  
)

export default component.exports